import * as Yup from 'yup';

import { OptionType } from '../dto/asset.dto';
import { SelectOption } from '../dto/template.dto';

Yup.addMethod<Yup.ArraySchema<any>>(Yup.array, 'uniqueObjectArray', function (message, mapper) {
  return this.test('uniqueObjectArray', message, (list: SelectOption[] | undefined) => {
    if (list) {
      return list.length === new Set(list.map(mapper)).size;
    }
    return true;
  });
});

Yup.addMethod<Yup.ArraySchema<any>>(Yup.array, 'uniqueObjectArrayLabel', function (message, mapper) {
  return this.test('uniqueObjectArrayLabel', message, (list: OptionType[] | undefined) => {
    if (list) {
      return list.length === new Set(list.map(mapper)).size;
    }
    return true;
  });
});

declare module 'yup' {
  interface ArraySchema<T> {
    uniqueObjectArray(message: string, isEqual: (value: SelectOption) => string): ArraySchema<T>;
  }
  interface ArraySchema<T> {
    uniqueObjectArrayLabel(message: string, isEqual: (value: OptionType) => string): ArraySchema<T>;
  }
}

export default Yup;
